import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight, Mail, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT } from "./content";

const ContactCta = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <section ref={ref} className="relative overflow-hidden" data-testid="contact-section">
      <motion.img src="/img/night-road.jpg" alt="" style={{ y }} className="absolute inset-0 h-[124%] w-full object-cover" />
      <div className="absolute inset-0 bg-asphalt/80" />
      <div className="relative mx-auto max-w-[1400px] px-5 py-28 sm:px-8 lg:py-40">
        <p className="font-mono text-xs uppercase tracking-[0.28em] text-lane">Talk to a licensed Georgia agent</p>
        <h2 className="mt-6 max-w-5xl font-display text-6xl font-black uppercase leading-[0.88] text-bone sm:text-8xl lg:text-[9rem]">Let's get them on the road.</h2>
        <div className="mt-12 grid gap-4 md:grid-cols-2">
          <a href={CONTACT.tel} data-testid="contact-call-btn" className="group flex items-center justify-between rounded-[1.75rem] bg-lane p-7 text-asphalt transition-transform duration-300 hover:-translate-y-1">
            <span>
              <span className="flex items-center gap-2 font-mono text-xs font-bold uppercase tracking-[0.2em]"><Phone className="h-4 w-4" /> Call</span>
              <span className="mt-2 block font-display text-4xl font-black sm:text-5xl">{CONTACT.phone}</span>
            </span>
            <ArrowUpRight className="h-8 w-8 transition-transform duration-300 group-hover:rotate-45" />
          </a>
          <a href={`mailto:${CONTACT.email}?subject=${encodeURIComponent("Teen Driver Quote")}`} data-testid="contact-email-btn" className="group flex items-center justify-between rounded-[1.75rem] border border-white/20 bg-asphalt/70 p-7 text-bone backdrop-blur-xl transition-colors duration-300 hover:border-lane">
            <span className="min-w-0">
              <span className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-lane"><Mail className="h-4 w-4" /> Email</span>
              <span className="mt-2 block break-words font-display text-[1.35rem] font-black sm:text-4xl">{CONTACT.email}</span>
            </span>
            <ArrowUpRight className="h-8 w-8 shrink-0 transition-transform duration-300 group-hover:rotate-45" />
          </a>
        </div>
      </div>
    </section>
  );
};

export const Footer = () => (
  <>
    <ContactCta />
    <footer className="border-t border-white/10 bg-asphalt" data-testid="site-footer">
      <div className="mx-auto grid max-w-[1400px] gap-10 px-5 py-14 sm:px-8 md:grid-cols-3">
        <div>
          <Logo />
          <p className="mt-5 max-w-xs font-body text-sm leading-relaxed text-mist">{CONTACT.agency} · Licensed Property &amp; Casualty Insurance Agent in {CONTACT.state}.</p>
        </div>
        <div className="font-body text-sm text-mist">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-lane">Contact</p>
          <a href={CONTACT.tel} className="mt-4 block text-bone hover:text-lane" data-testid="footer-phone-link">{CONTACT.phone}</a>
          <a href={`mailto:${CONTACT.email}`} className="mt-2 block break-all text-bone hover:text-lane" data-testid="footer-email-link">{CONTACT.email}</a>
          <p className="mt-2" data-testid="footer-domain">{CONTACT.domain}</p>
        </div>
        <p className="font-body text-xs leading-relaxed text-mist">
          Discount availability, eligibility and amounts vary by insurance company and individual circumstances. Descriptions on this site are general information, not a quote or a guarantee of coverage or savings.
        </p>
      </div>
      <div className="border-t border-white/10 py-6 text-center font-mono text-xs text-mist">© 2026 {CONTACT.agency} · {CONTACT.domain}</div>
    </footer>
  </>
);
